import { Prefill } from '@library/formBuilder/prefill';
import type { AtomModel } from '@models/atom.model';
import type { TextFieldData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<TextFieldData>;
};

export const TextFieldModal = ({ atom }: Props) => (
  <>
    <Prefill atom={atom} />
  </>
);
